import { API_CONFIG, apiUtils } from '../config.js';

// Unit (Class/Branch) Management API
export const unitApi = {
  // Get all units
  getAllUnits: async () => {
    const url = `${API_CONFIG.BASE_URL}/unit-kind/all`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Create unit
  createUnit: async (unitData) => {
    const url = `${API_CONFIG.BASE_URL}/unit-kind/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(unitData),
    });
  },

  // Update unit
  updateUnit: async (unitId, unitData) => {
    const url = `${API_CONFIG.BASE_URL}/unit-kind/update/${unitId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(unitData),
    });
  },

  // Delete unit
  deleteUnit: async (unitId) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        ...(token && { 'Authorization': `Bearer ${token}` })
      };

      const response = await fetch(`${API_CONFIG.BASE_URL}/unit-kind/delete/${unitId}`, {
        method: 'DELETE',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { success: true };
    } catch (error) {
      apiUtils.handleError(error);
      throw error;
    }
  },

  // Assign teacher to unit
  assignTeacherToUnit: async (unitId, teacherId) => {
    const url = `${API_CONFIG.BASE_URL}/unit-kind/assign-teacher-to-unit/${unitId}/${teacherId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
    });
  },

  // Get unit details
  getUnitById: async (unitId) => {
    const url = `${API_CONFIG.BASE_URL}/unit-kind/get-by-id/${unitId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get students of unit
  getStudentsOfUnit: async (unitId, academicYear) => {
    let url = `${API_CONFIG.BASE_URL}/unit-kind/get-all-students-of-unit/${unitId}`;
    if (academicYear) {
      url += `?academicYear=${academicYear}`;
    }
    return apiUtils.makeAuthenticatedRequest(url);
  },
};

export default unitApi;
